import React from "react";
import { IconMoreHoriz } from "@wrstudios/icons";
import Menu from "../menu";
import { Container, MenuButton, MenuList, MenuItemDelete } from "./styled/photo-card-menu";
function PhotoCardMenu(_a) {
    var deleteLabel = _a.deleteLabel, handleClickDelete = _a.handleClickDelete;
    return (React.createElement(Container, null,
        React.createElement(Menu, null,
            React.createElement(MenuButton, { "aria-label": "More Options" },
                React.createElement(IconMoreHoriz, { "aria-hidden": true })),
            React.createElement(MenuList, null,
                React.createElement(MenuItemDelete, { onClick: handleClickDelete }, deleteLabel)))));
}
export default PhotoCardMenu;
